// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1-JU6","content":"styles_content__2ID7W","checkbox":"styles_checkbox__32Q40","checkboxLabel":"styles_checkboxLabel__AorNm"};